import { render, staticRenderFns } from "./banner-pending.vue?vue&type=template&id=08eacac0"
import script from "./banner-pending.vue?vue&type=script&lang=js"
export * from "./banner-pending.vue?vue&type=script&lang=js"
import style0 from "./banner-pending.vue?vue&type=style&index=0&id=08eacac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports